module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Erweiterte Unternehmenssuche"},"fr":{"title":"Recherche avancée d’entreprise"},"it":{"title":"Ricerca avanzata dell\u0027azienda"}}')
  delete Component.options._Ctor
}
